
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Settings as settings } from "@env/main";


    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        public Abierto: boolean = false;
        public get Controlador() { return Vue.observable( settings ); };

    }
